import React, { Component } from "react";
import FaqContent from "../function-components/FaqContent/FaqContent";

export class Faq extends Component {
  render() {
    return (
      <>
        <FaqContent />
      </>
    );
  }
}

export default Faq;
